import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Briefcase, Radio, GraduationCap, Hotel, Calendar, ImagePlus } from 'lucide-react';

const audiences = [
  { icon: Building2, label: 'Empresas e Marcas' },
  { icon: Briefcase, label: 'Profissionais Liberais' },
  { icon: Radio, label: 'Criadores de Conteúdo' },
  { icon: GraduationCap, label: 'Especialistas e Empreendedores' },
  { icon: Hotel, label: 'Hotéis e Turismo' },
  { icon: Calendar, label: 'Organizadores de Eventos' },
  { icon: ImagePlus, label: 'Fotos e Vídeos Profissionais' },
];

const StudioAudience = () => {
  return (
    <section
      id="para-quem"
      data-testid="studio-audience"
      className="relative py-24 md:py-32 bg-[#0B0B0F] border-t border-white/5 overflow-hidden"
    >
      <div className="container mx-auto px-6 lg:px-12 relative z-10 max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start"
        >
          <div className="lg:col-span-5">
            <span className="text-[10px] md:text-xs uppercase tracking-[0.4em] font-bold text-[#2540A3] mb-4 inline-block">
              Para Quem É
            </span>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-black text-[#F5F5F0] leading-[1.05] mb-6">
              Para quem é a{' '}
              <span className="text-[#2540A3] italic">COUTIN STUDIO?</span>
            </h2>
            <p className="text-base md:text-lg text-[#A1A1AA] font-light leading-relaxed">
              Seja para gravar uma conversa, apresentar sua marca, produzir imagens
              ou tirar uma ideia do papel, a COUTIN STUDIO será um espaço pensado
              para você.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {audiences.map((a, i) => {
              const Icon = a.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  data-testid={`audience-item-${i}`}
                  className="group flex items-center gap-4 px-5 py-4 rounded-xl border border-white/8 hover:border-[#2540A3]/50 bg-gradient-to-br from-[#141419] to-[#0B0B0F] transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-lg bg-[#2540A3]/12 border border-[#2540A3]/30 flex items-center justify-center shrink-0 group-hover:bg-[#2540A3]/20 transition-all">
                    <Icon className="w-4.5 h-4.5 text-[#2540A3]" strokeWidth={2} />
                  </div>
                  <span className="text-sm md:text-base text-[#F5F5F0] font-medium">
                    {a.label}
                  </span>
                </motion.div>
              );
            })}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StudioAudience;
